import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_DISTRICT: '/GetDistrict',
  GET_NEIGHBORHOOD: '/GetNeighborhood',
  GET_ALL_NEIGHBORHOODS: '/GetAllNeighborhood',
  GET_STREET: '/GetStreet',
  GET_APARTMENT: '/GetApartment',
  GET_APARTMENT_DETAILS: '/GetApartmentDetailsDB',
  GET_APARTMENTS_DETAILS: '/GetApartmentsDetailsDB',
  GET_MAHALLE_OZET_LISTESI: '/GetMahalleOzetListesi',
  ADDRESS_TO_GROUP_ADD: '/AddressToGroupAdd',
  ADDRESS_TO_GROUP_ADDS: '/AddressToGroupAdds',
  ADDRESS_TO_GROUP_AND_PERSONEL_ADDS: '/AddressToGroupAndPersonelAdds',
  GET_BLOCKED_ADDRESSES: '/GetBlockLists',
  GET_BLOCK_OPTIONS: '/BlockOptionsYntList',
  DELETE_BLOCKED_ADDRESS: '/BlockRemove',
  GET_BLOCKED_LIST_EXCEL: '/GetBlockListsExcel',
  GET_PLAN_LIST: '/NeighborhoodPlanList',
  DELETE_PLAN: '/NeighborhoodPlanDelete',
  DELETE_PLAN_PERSONEL: '/NeighborhoodPlanPersonelDelete',
  GET_PLAN_SOKAK_LIST: '/NeighborhoodPlanSokakList',
  ADD_PLAN_SOKAK: '/NeighborhoodPlanSokakAdd',
  DELETE_PLAN_SOKAK: '/NeighborhoodPlanSokakDelete',
  GET_ADDRESS_LIST: '/GetAdresList',
  UPDATE_ADDRESS: '/UpdateAdres',
  HIM_RECORD_QUERY: '/HimKayitSorgulama',
}

export const getDistricts = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_DISTRICT + '?city=izmir');
  return response.data;
};

export const getNeighborhoods = async (districtId) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_NEIGHBORHOOD + '?district=' + encodeURIComponent(districtId));
  return response.data;
};

export const getAllNeighborhoods = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_ALL_NEIGHBORHOODS);
  return response.data;
};

export const getStreets = async (neighborhoodId) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_STREET + '?neighborhood=' + encodeURIComponent(neighborhoodId));
  return response.data;
};

export const getApartments = async (neighborhoodId, streetId) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_APARTMENT + '?neighborhood=' + encodeURIComponent(neighborhoodId) + '&street=' + encodeURIComponent(streetId));
  return response.data;
};

export const getApartmentDetails = async (neighborhood, street) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_APARTMENT_DETAILS + '?street=' + street + '&neighborhood=' + neighborhood);
  return response.data;
};

export const getApartmentsDetails = async (neighborhood, district) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_APARTMENTS_DETAILS + '?neighborhood=' + neighborhood + '&district=' + district);
  return response.data;
};

// İlçe seçilip mahalle seçilmediğinde: ilçenin her mahallesi için hane/sokak özeti.
// Parametre ilçe ADIdır (id değil) — backend AddressTable.ilce ile karşılaştırıyor.
export const getMahalleOzetListesi = async (ilce) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_MAHALLE_OZET_LISTESI + '?ilce=' + encodeURIComponent(ilce)
  );
  return response.data;
};

export const addressToGroupAdds = async (adresids, group) => {
  const formData = new FormData();
  formData.append('adresids', adresids);
  formData.append('group', group);
  const token = localStorage.getItem('token');
  const response = await axiosInstance.post(
    ENDPOINTS.ADDRESS_TO_GROUP_ADDS,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const addressToGroupAndPersonelAdds = async (ilce, mahalle, sokakAdlari, personelIds, group) => {
  const formData = new FormData();
  formData.append('ilce', ilce);
  formData.append('mahalle', mahalle);
  formData.append('sokakadlari', sokakAdlari);
  formData.append('personelids', personelIds);
  formData.append('gun', group);
  formData.append('group', group);
 
  const token = localStorage.getItem('token');
  const response = await axiosInstance.post(
    ENDPOINTS.ADDRESS_TO_GROUP_AND_PERSONEL_ADDS,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    }
  );
  return response;
};

export const getPersonelTask = async  (planid, userid) => {
  const response = await axiosInstance.get(`/TaskToNewPersonel?NBId=${encodeURIComponent(planid)}&PersonelId=${encodeURIComponent(userid)}`);
  return response.data;
};
export const getPersonelComeToWork = async  () => {
  const today = new Date().toISOString().split("T")[0];
  const response = await axiosInstance.get(`/GetUserComeToWorks?baslangic=${today}`);
  
  return response.data;
};
export const getPlanList = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_PLAN_LIST);
  return response.data;
};

export const deletePlan = async (id) => {
  const response = await axiosInstance.get(ENDPOINTS.DELETE_PLAN + `?id=${id}`);
  return response.data;
};
export const deletePlanPersonel = async (planId, personelId) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.DELETE_PLAN_PERSONEL + `?planId=${encodeURIComponent(planId)}&personelId=${encodeURIComponent(personelId)}`
  );
  return response.data;
};

// Planın sokakları + mahallede plana eklenebilecek sokaklar (hane/görev adetleriyle).
export const getPlanSokakList = async (planId) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_PLAN_SOKAK_LIST + `?planId=${encodeURIComponent(planId)}`
  );
  return response.data;
};

// Sokak adları virgül içerebileceği varsayımına düşmemek için gövdede dizi olarak taşınır.
export const addPlanSokak = async (planId, sokaklar, personelIds) => {
  const response = await axiosInstance.post(ENDPOINTS.ADD_PLAN_SOKAK, {
    planId,
    sokaklar,
    personelIds,
  });
  return response.data;
};

// personelIds boş dizi/undefined ise sokak TÜM personellerden silinir (backend sözleşmesi).
export const deletePlanSokak = async (planId, sokaklar, personelIds) => {
  const response = await axiosInstance.delete(ENDPOINTS.DELETE_PLAN_SOKAK, {
    data: { planId, sokaklar, personelIds },
  });
  return response.data;
};
export const postPersonelTask = async (perid, taskids) => {
  const formData = new FormData();
  formData.append('PersonelId', perid);
  formData.append('TaskIds', taskids);
  const token = localStorage.getItem('token');
  const response = await axiosInstance.post(
    '/TaskToNewPersonel',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const addressToGroupAdd = async (apartmentId, groupname) => {
  const formData = new FormData();
  formData.append('groupname', groupname);
  const token = localStorage.getItem('token');
  const response = await axiosInstance.post(
    ENDPOINTS.ADDRESS_TO_GROUP_ADD + '/' + apartmentId,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getBlockedAddresses = async (params) => {
  const {type, count, offset, date, search} = params;
  const response = await axiosInstance.get(ENDPOINTS.GET_BLOCKED_ADDRESSES, { params: {type, count, offset, date, search} });
  return response.data;
};

export const getBlockOptions = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_BLOCK_OPTIONS);
  return response.data;
};

export const deleteBlockedAddress = async (id) => {
  const response = await axiosInstance.post(ENDPOINTS.DELETE_BLOCKED_ADDRESS + '/' + id);
  return response.data;
};

export const getBlockedListExcel = async (params) => {
  const {type, date, search} = params;
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_BLOCKED_LIST_EXCEL}`;
  
  // Build query parameters
  const queryParams = new URLSearchParams();
  if (type) queryParams.append('type', type);
  if (date) queryParams.append('date', date);
  if (search) queryParams.append('search', search);
  
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }
  
  const response = await fetch(url, {
    headers: {
      'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Excel indirme işlemi başarısız oldu');
  }

  return response;
};

export const getAddressList = async (params) => {
  const {count, offset, kapino, fulladres} = params;
  const response = await axiosInstance.get(ENDPOINTS.GET_ADDRESS_LIST, { params: {count, offset, kapino, fulladres} });
  return response.data;
};

export const updateAddress = async (params) => {
  const response = await axiosInstance.put(ENDPOINTS.UPDATE_ADDRESS, params);
  return response.data;
};

export const himRecordQuery = async (params) => {
  const response = await axiosInstance.post(ENDPOINTS.HIM_RECORD_QUERY, params);
  return response.data;
};